import React from "react";

const EFTs = () => {
  return <div>EFTs</div>;
};

export default EFTs;
